<nb-card class="ticket-card">
  <nb-card-header>
    <div class="header-container">
      <div>Ticket Invoice</div>
      <div>
      <button  class="tck-custom-action-btn mx-2" status="success" (click)="exportAsPdf()">
  <nb-icon icon="download-outline"></nb-icon>
  <span class="btn-label">Export as PDF</span>
</button>
<button  class="tck-custom-action-btn" status="info" (click)="sendToMail()">
  <nb-icon icon="email-outline"></nb-icon>
  <span class="btn-label">Send to Mail</span>
</button>
      </div>
    </div>
  </nb-card-header>
  <nb-card-body nbSpinnerOverlay [nbSpinnerMessage]="spinnerMainMsg" nbSpinnerSize="giant" [nbSpinner]="loading" nbSpinnerStatus="basic" class="ticket-body"> 
    <div [innerHTML]="ticketHtml"></div>
  </nb-card-body>
  

  <nb-card-footer>
    <div class="d-foot-action">
        <button nbButton status="danger" (click)="close()">Close</button></div>
  </nb-card-footer>
</nb-card>